import { ApolloError, useLazyQuery } from "@apollo/client";
import { AuthContext } from "context";
import { formatCompanyReport } from "formatters";
import { COMPANY_REPORT, CONFIG } from "graphql/query";
import { useSelectedLanguage } from "language";
import React, { createContext, useContext, useState } from "react";
import { CompanyReport } from "types";

interface CompanyContextState {
  setCompanyID: any;
  loadingCompany: boolean;
  loadingConfig: boolean;
  error: ApolloError | undefined;
  company: CompanyReport;
  config: { featureIssue: string; disclaimer: string };
  getCompany: () => {};
  getConfig: () => {};
}

export const CompanyContext = createContext({} as CompanyContextState);

export const CompanyProvider = ({
  children,
}: {
  children: React.ReactElement;
}) => {
  const { userData } = useContext(AuthContext);
  const [companyID, setCompanyID] = useState<number | string>();
  const { selectedLanguage, selectedDictionary } = useSelectedLanguage();
  const companyFilters: any = {};

  if (userData?.orgId) {
    companyFilters.organization = {
      id: {
        eq: userData.orgId,
      },
    };
  }

  const [
    getCompany,
    { data: companyReport, loading: loadingCompany, error: companyReportError },
  ] = useLazyQuery(COMPANY_REPORT, {
    variables: {
      id: companyID,
      filters: companyFilters,
    },
  });
  const [
    getConfig,
    { data: config, loading: loadingConfig, error: configError },
  ] = useLazyQuery(CONFIG);

  const iState = {
    setCompanyID,
    error: companyReportError && configError,
    loadingCompany,
    loadingConfig,
    company: formatCompanyReport(
      companyReport?.company?.data?.attributes,
      companyReport?.company?.data?.id,
      selectedDictionary,
      selectedLanguage
    ),
    getCompany,
    config: {
      featureIssue:
        config?.config?.data?.attributes?.featureIssue?.data?.attributes?.name,
      disclaimer: config?.config?.data?.attributes?.disclaimer,
    },
    getConfig,
  } as CompanyContextState;

  return (
    <CompanyContext.Provider value={iState}>{children}</CompanyContext.Provider>
  );
};
